import {
  REQUEST_ERN_REF_NETWORK,
  RESPONSE_ERN_REF_NETWORK,
  FAILURE_ERN_REF_NETWORK
} from "../../actions/types";

const initialState = {
  keyword: "",
  isFetching: false,
  statusCode: 0,
  results: {},
  error: false,
  isAdmin: false,
  isInitalScreen: true,
  size: 10,
  from: 0,
  activePage: 1,
  total: 0,
  sort: {
    label: "NAME",
    value: "name"
  },
  keywords: "MetabERN",
  country: "",
  city: ""
};

const setFetching = (state, action) => {
  return {
    ...state,
    isFetching: true,
    isAdmin: false,
    statusCode: 0,
    results: {},
    isInitalScreen: false,
    keywords: action.payload.keywords || "",
    city: action.payload.city || "",
    country: action.payload.country || ""
  };
};

const setFailure = (state, action) => {
  return {
    ...state,
    isFetching: false,
    error: true,
    results: {}
  };
};

const setResults = (state, action) => {
  let results = action.payload.results || {};
  let isAdmin = action.payload.isAdmin;

  let total = action.payload.total;

  return {
    ...state,
    isFetching: false,
    error: false,
    results: results,
    isAdmin: isAdmin,
    total: total,
    results: results
  };
  
};

export default (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_ERN_REF_NETWORK:
      return setFetching(state, action);
      break;

    case RESPONSE_ERN_REF_NETWORK:
      return setResults(state, action);

    case FAILURE_ERN_REF_NETWORK:
      return setFailure(state, action);

    default:
      return state;
      break;
  }
};
